module.exports = __webpack_public_path__ + "fdfbf9f56ecc9b8a5947aef20d66c4fa.jpg";